/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Open_NewestInputs */

const en_us2_draft_open_newest = /** @type {(inputs: Draft_Open_NewestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review the new version`)
};

const pt_br2_draft_open_newest = /** @type {(inputs: Draft_Open_NewestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar a versão nova`)
};

const es_419_draft_open_newest = /** @type {(inputs: Draft_Open_NewestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar la versión nueva`)
};

const pt_pt2_draft_open_newest = /** @type {(inputs: Draft_Open_NewestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rever a versão nova`)
};

const fr_fr2_draft_open_newest = /** @type {(inputs: Draft_Open_NewestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revoir la nouvelle version`)
};

const de_de2_draft_open_newest = /** @type {(inputs: Draft_Open_NewestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Version prüfen`)
};

const it_it2_draft_open_newest = /** @type {(inputs: Draft_Open_NewestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rivedi la nuova versione`)
};

/**
* | output |
* | --- |
* | "Review the new version" |
*
* @param {Draft_Open_NewestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_open_newest = /** @type {((inputs?: Draft_Open_NewestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Open_NewestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_open_newest(inputs)
	if (locale === "es-419") return es_419_draft_open_newest(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_open_newest(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_open_newest(inputs)
	if (locale === "de-DE") return de_de2_draft_open_newest(inputs)
	if (locale === "it-IT") return it_it2_draft_open_newest(inputs)
	return en_us2_draft_open_newest(inputs)
});
export { draft_open_newest as "draft.open_newest" }